import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, useParams, Navigate } from 'react-router-dom';


import SignIn from './pages/Auth/SignIn'
import OAuth2Process from './pages/Auth/OAuth2Process';
import RequireAuth from './RequireAuth';

import Navbar from './components/Navbar';
import Home from './pages/Home/Index'
import Announcement from "./pages/Announcement/Index"
import AnnouncementDetail from "./pages/Announcement/Detail"
import AnnouncementCreate from './pages/Announcement/Create'
import Finance from './pages/Finance/Index'
import Signature from "./pages/Signature/Index"
import Training from './pages/Training/Index'
import TrainingDetail from './pages/Training/Detail'
import Service from './pages/Service/Index'
import ServiceDetail from './pages/Service/Detail'
import File from './pages/File/Index'
import Report from './pages/Report/Index'
import Assessment from './pages/Assessment/Index'
import AssessmentConsent from './pages/Assessment/Consent'
import AuditCenter from './pages/AuditCenter/Index'
import AuditCenterHub from './pages/AuditCenter/Hub'
import AuditCenterFindings from './pages/AuditCenter/Findings/FindingsShell'
import AuditCenterRunbook from './pages/AuditCenter/Audit'
import FleetReport from './pages/FleetReport/Index'
import EndpointDevicesPage from './pages/EndpointDevice/EndpointDevicesPage'
import EndpointDevicePage from './pages/EndpointDevice/EndpointDevicePage'
import SoftwarePolicyPage from './pages/SoftwarePolicy/SoftwarePolicyPage'
import SoftwareDriftPage from './pages/SoftwareDrift/SoftwareDriftPage'
import SoftwareBuilderPage from './pages/SoftwareBuilder/SoftwareBuilderPage'
import BotReportsPage from './pages/BotReport/BotReportsPage'
import BotReportPage from './pages/BotReport/BotReportPage'
import Processing from './pages/Processing/Index'
import Operations from './pages/Operation/Index'
import SonicWall from './pages/Operation/SonicWall'
import SonicWallAudit from './pages/Operation/SonicWallAudit'
import UnifiHealth from './pages/Operation/UnifiHealth'
import WindowsEndpointAudit from './pages/Operation/WindowsEndpointAudit'

import QbrIndex from './pages/Qbr/Index'
import QbrHub from './pages/Qbr/Hub'
import QbrCalendar from './pages/Qbr/Calendar'
import QbrProgramDetail from './pages/Qbr/Program/Detail'
import QbrProgramCreate from './pages/Qbr/Program/Create'
import QbrCycleDetail from './pages/Qbr/Cycle/Detail'

import CustomerIndex from './pages/Customer/Index'
import CustomerDetail from './pages/Customer/Detail'
import WarrantyIndex from './pages/Warranty/Index'
import WarrantyDetail from './pages/Warranty/Detail'

import AdminEnvelopeOpen from './pages/Admin/EnvelopeOpen/Index'
import AdminSignatureRequest from './pages/Admin/EnvelopeOpen/Request'
import AdminEnvelopeSigned from './pages/Admin/EnvelopeSigned/Index'
import VersionFooter from './components/VersionFooter'
import V2App from './v2/V2App'
import V3App from './v3/V3App'
import './App.css';


import logo from './logo.svg';

// The current site: the top navbar, the footer and all of its pages.
function ClassicApp() {

  useEffect(() => {
    const adjustBodyPadding = () => {
      const appBarHeight = document.querySelector('nav').offsetHeight;
      document.body.style.paddingTop = `${appBarHeight}px`;

    };

    adjustBodyPadding();
    window.addEventListener('resize', adjustBodyPadding);

    return () => {
      window.removeEventListener('resize', adjustBodyPadding);
      document.body.style.paddingTop = '';          // V2 has no top navbar
    };
  }, []);


  return (
  <>
    <Navbar />
    <VersionFooter />
      <Routes>
      <Route path="/" element={<SignIn />} />
      <Route path="/auth/signin" element={<SignIn />} />
      <Route path="/auth/oauth2process" element={<OAuth2Process />} />

      <Route path={'/home'} element={
            <RequireAuth roles={[]} >
                <Home />
            </RequireAuth>
        }/>
        
      <Route path={'/announcement/create'} element={
            <RequireAuth roles={[]} >
                <AnnouncementCreate />
            </RequireAuth>
        }/>

         <Route path={'/announcement'} element={
            <RequireAuth roles={[]} >
                <Announcement />
            </RequireAuth>
        }/> 
         <Route path={'/announcement/detail/:id'} element={
            <RequireAuth roles={[]} >
                <AnnouncementDetail />
            </RequireAuth>
        }/>  
        <Route path={'/file'} element={
            <RequireAuth roles={[]} >
                <File />
            </RequireAuth>
        }/>   
             
        <Route path={'/signature'} element={
            <RequireAuth roles={[]} >
                <Signature />
            </RequireAuth>
        }/>     

        <Route path={'/report'} element={
            <RequireAuth roles={[]} >
                <Report />
            </RequireAuth>
        }/> 
        <Route path={'/assessment'} element={
            <RequireAuth roles={[]} >
                <Assessment />
            </RequireAuth>
        }/> 
        <Route path={'/assessment/consent'} element={
            <RequireAuth roles={[]} >
                <AssessmentConsent />
            </RequireAuth>
        }/>
        <Route path={'/audit'} element={
            <RequireAuth roles={[]} >
                <AuditCenterHub />
            </RequireAuth>
        }/>
        <Route path={'/audit/findings'} element={
            <RequireAuth roles={[]} >
                <AuditCenter />
            </RequireAuth>
        }/>
        <Route path={'/audit/findings/:auditType'} element={
            <RequireAuth roles={[]} >
                <AuditCenterFindings />
            </RequireAuth>
        }/>
        <Route path={'/audit/runbook'} element={
            <RequireAuth roles={[]} >
                <AuditCenterRunbook />
            </RequireAuth>
        }/>
        {/* Backwards-compatible redirects for the legacy CMA Assessment paths.
            Remove after 3 release cycles — see wiki Audits/Migration-From-Reports.md. */}
        <Route path={'/cmaassessment'} element={<Navigate to="/audit/findings" replace />}/>
        <Route path={'/cma-assessment/audit'} element={<Navigate to="/audit/runbook" replace />}/>
        {/* Admin-only: cma/endpointdevice writes are admin-only server-side. */}
        <Route path={'/endpointdevices'} element={
            <RequireAuth roles={['admin']} >
                <EndpointDevicesPage />
            </RequireAuth>
        }/>
        <Route path={'/endpointdevices/:deviceId'} element={
            <RequireAuth roles={['admin']} >
                <EndpointDevicePage />
            </RequireAuth>
        }/>
        {/* Admin-only: cma/softwarepolicy writes are admin-only server-side. */}
        <Route path={'/softwarepolicy'} element={
            <RequireAuth roles={['admin']} >
                <SoftwarePolicyPage />
            </RequireAuth>
        }/>
        <Route path={'/softwarebuilder'} element={
            <RequireAuth roles={['admin']} >
                <SoftwareBuilderPage />
            </RequireAuth>
        }/>
        <Route path={'/softwaredrift'} element={
            <RequireAuth roles={['admin']} >
                <SoftwareDriftPage />
            </RequireAuth>
        }/>
        {/* Reports the bots wrote. Any signed-in user; the API only returns the accounts the user may see. */}
        <Route path={'/botreports'} element={
            <RequireAuth roles={[]} >
                <BotReportsPage />
            </RequireAuth>
        }/>
        <Route path={'/botreports/:reportId'} element={
            <RequireAuth roles={[]} >
                <BotReportPage />
            </RequireAuth>
        }/>
                <Route path={'/fleet'} element={
            <RequireAuth roles={[]} >
                <FleetReport />
            </RequireAuth>
        }/>
        <Route path={'/processing'} element={
            <RequireAuth roles={[]} >
                <Processing />
            </RequireAuth>
        }/> 
        <Route path={'/operation'} element={
            <RequireAuth roles={[]} >
                <Operations />
            </RequireAuth>
        }/>
        <Route path={'/operation/sonicwall'} element={
            <RequireAuth roles={[]} >
                <SonicWall />
            </RequireAuth>
        }/>
        <Route path={'/operation/sonicwall/audit'} element={
            <RequireAuth roles={[]} >
                <SonicWallAudit />
            </RequireAuth>
        }/>
        <Route path={'/operation/unifi'} element={
            <RequireAuth roles={[]} >
                <UnifiHealth />
            </RequireAuth>
        }/>
        <Route path={'/operation/windows/audit'} element={
            <RequireAuth roles={[]} >
                <WindowsEndpointAudit />
            </RequireAuth>
        }/>

        {/* QBR */}
        <Route path={'/qbr'} element={
            <RequireAuth roles={[]} >
                <QbrIndex />
            </RequireAuth>
        }/>
        <Route path={'/qbr/hub'} element={
            <RequireAuth roles={[]} >
                <QbrHub />
            </RequireAuth>
        }/>
        <Route path={'/qbr/calendar'} element={
            <RequireAuth roles={[]} >
                <QbrCalendar />
            </RequireAuth>
        }/>
        <Route path={'/qbr/program/new'} element={
            <RequireAuth roles={['admin']} >
                <QbrProgramCreate />
            </RequireAuth>
        }/>
        <Route path={'/qbr/program/:id'} element={
            <RequireAuth roles={[]} >
                <QbrProgramDetail />
            </RequireAuth>
        }/>
        <Route path={'/qbr/cycle/:id'} element={
            <RequireAuth roles={[]} >
                <QbrCycleDetail />
            </RequireAuth>
        }/>

        {/* Customer Center — CRUD on accountprofile entries */}
        <Route path={'/customer'} element={
            <RequireAuth roles={[]} >
                <CustomerIndex />
            </RequireAuth>
        }/>
        <Route path={'/customer/:code'} element={
            <RequireAuth roles={[]} >
                <CustomerDetail />
            </RequireAuth>
        }/>

        {/* Warranty Center — Datto warrantyDate by customer. Admin: datto/* is admin-only. */}
        <Route path={'/warranty'} element={
            <RequireAuth roles={['admin']} >
                <WarrantyIndex />
            </RequireAuth>
        }/>
        <Route path={'/warranty/:code'} element={
            <RequireAuth roles={['admin']} >
                <WarrantyDetail />
            </RequireAuth>
        }/>

        <Route path={'/finance'} element={
            <RequireAuth roles={[]} >
                <Finance />
            </RequireAuth>
        }/>  

        <Route path={'/training'} element={
            <RequireAuth roles={[]} >
                <Training />
            </RequireAuth>
        }/>   
        <Route path={'/training/detail/:id'} element={
            <RequireAuth roles={[]} >
                <TrainingDetail />
            </RequireAuth>
        }/>  
        <Route path={'/service'} element={
            <RequireAuth roles={[]} >
                <Service />
            </RequireAuth>
        }/>   
        <Route path={'/service/detail/:id'} element={
            <RequireAuth roles={[]} >
                <ServiceDetail />
            </RequireAuth>
        }/>  
        <Route path={'/admin/envelopeopen'} element={
            <RequireAuth roles={['admin']} >
                <AdminEnvelopeOpen />
            </RequireAuth>
        }/>       
        <Route path={'/admin/envelopeopen/request'} element={
            <RequireAuth roles={['admin']} >
                <AdminSignatureRequest />
            </RequireAuth>
        }/>
        <Route path={'/admin/envelopesigned'} element={
            <RequireAuth roles={['admin']} >
                <AdminEnvelopeSigned />
            </RequireAuth>
        }/>                                                   
    </Routes>
  </>
  );
}

// /v2 is a separate site inside this one: its own layout, sign-in and colours. Everything else is the current site, as it was.
const isV2 = (pathname) => pathname === '/v2' || pathname.startsWith('/v2/');
// /v3 is the same idea: its own layout, sign-in and colours, replacing V2 when V2 is removed.
const isV3 = (pathname) => pathname === '/v3' || pathname.startsWith('/v3/');

function Switcher() {
  const { pathname } = useLocation();
  if (isV3(pathname)) return <V3App />;
  return isV2(pathname) ? <V2App /> : <ClassicApp />;
}

function App() {
  return (
    <Router>
      <Switcher />
    </Router>
  );
}

export default App;
